import PropTypes from 'prop-types'
import { createContext, useContext, useMemo } from 'react'

import { useForgotPassword } from './useForgotPassword'
import { useSession } from './useSession'

const AuthContext = createContext(null)

export const useAuthContext = () => useContext(AuthContext)

const AuthProvider = ({ logoutCallback, children }) => {
  const {
    requestPasswordResetState,
    setDefaultRequestPasswordResetState,
    sendVerificationCode,
    resendConfirmationCode,
    resetPasswordState,
    setDefaultResetPasswordState,
    resetPassword,
  } = useForgotPassword()

  const { session, login, logout, updateTokens, changePassword } = useSession({
    logoutCallback,
  })

  const loginContext = useMemo(
    () => ({
      requestPasswordResetState,
      setDefaultRequestPasswordResetState,
      sendVerificationCode,
      resendConfirmationCode,
      resetPasswordState,
      setDefaultResetPasswordState,
      resetPassword,
      login,
      logout,
      updateTokens,
      changePassword,
      user: session.user,
      refreshToken: session.refreshToken,
      idToken: session.idToken,
      accessToken: session.accessToken,
      isLoggingIn: session.isLoggingIn,
      isLoggingOut: session.isLoggingOut,
      isLoggedIn: session.isLoggedIn,
      errors: session.errors,
      session,
    }),
    [
      requestPasswordResetState,
      setDefaultRequestPasswordResetState,
      sendVerificationCode,
      resendConfirmationCode,
      resetPasswordState,
      setDefaultResetPasswordState,
      resetPassword,
      login,
      logout,
      updateTokens,
      changePassword,
      session,
    ],
  )

  return (
    <AuthContext.Provider value={loginContext}>{children}</AuthContext.Provider>
  )
}

AuthProvider.propTypes = {
  logoutCallback: PropTypes.func.isRequired,
  children: PropTypes.node,
}

export default AuthProvider
